import { render, staticRenderFns } from "./Outfit.vue?vue&type=template&id=9f2109d0&scoped=true&"
import script from "./Outfit.vue?vue&type=script&lang=js&"
export * from "./Outfit.vue?vue&type=script&lang=js&"
import style0 from "./Outfit.vue?vue&type=style&index=0&id=9f2109d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2109d0",
  null
  
)

export default component.exports